import {
  AssetUpdateAttributesPayload,
  AssetUpdateLocationModel,
  AssetUpdateLocationPayload,
  AssetUpdateModel,
  AssetUpdatePayload,
} from '../models';

const updateAssetAttributesLocationToPayload = ({
  blockNumber,
  city,
  country,
  door,
  flat,
  postalCode,
  province,
  staircase,
  streetName,
  streetType,
}: AssetUpdateLocationModel): AssetUpdateLocationPayload => {
  return {
    block_number: blockNumber,
    city,
    country,
    door,
    flat,
    postal_code: postalCode,
    province,
    staircase,
    street_name: streetName,
    street_type: streetType,
  }
}

const updateAssetAttributesToPayload = ({
  alias,
  clientId,
  communityId,
  description,
  externalId,
  isBlocked,
  logo,
  type,
  location,
}: AssetUpdateModel): AssetUpdateAttributesPayload => {
  const transformedLocation = updateAssetAttributesLocationToPayload(location);

  return {
    alias,
    client_id: clientId,
    community_id: communityId,
    description,
    external_id: externalId,
    is_blocked: isBlocked,
    logo,
    type,
    location: transformedLocation,
  }
}

export const updateAssetToPayload = ({ assetId, data }: { assetId: string, data: AssetUpdateModel }): AssetUpdatePayload => {
  const transformedAttributes = updateAssetAttributesToPayload(data);

  return {
    id: assetId,
    attributes: transformedAttributes,
  }
}
